export default {"src":"/_next/static/media/favicon-codeai.c4fb742b.svg","height":180,"width":180,"blurWidth":0,"blurHeight":0};